/**
 * Feature 100 — /partner-trial request submission.
 * Guest-session token (minted behind reCAPTCHA) is auto-attached by apiClient.
 */

import { apiClient } from '@/core/api/client';

export type TrialRequestPayload = {
  firstName: string;
  lastName: string;
  businessEmail: string;
  companyName: string;
  jobTitle: string;
  phoneNumber?: string;
  firmWebsite?: string;
  hearAbout: string;
};

export async function submitTrialRequest(payload: TrialRequestPayload): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/trial-requests', payload);
  return response.data;
}
